export default __webpack_public_path__ + "static/media/sdr_tracker_preview.5286e320.png";